import { MagicConfigMixin } from '@gig/magic-common';
import { __extends, __decorate } from 'tslib';
import { Component, Mixins } from 'vue-property-decorator';
import '../icon/index.js';

// iOS doesn't fully support click on document
var documentClickEvent = 'ontouchstart' in document.documentElement ? 'touchstart' : 'click';
/**
 * Component renders a tooltip with a close button inside. Tooltip allows the
 * user to interact in two ways: by clicking on a close button or clicking
 * outside to close a tooltip.
 */
var StickyTooltipComponent = /** @class */ (function (_super) {
    __extends(StickyTooltipComponent, _super);
    function StickyTooltipComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isOpen = false;
        _this.handler = null;
        return _this;
    }
    StickyTooltipComponent.prototype.openTooltip = function () {
        this.handler = this.onDocumentClick.bind(this);
        document.addEventListener(documentClickEvent, this.handler);
        this.isOpen = true;
    };
    StickyTooltipComponent.prototype.closeTooltip = function () {
        if (this.handler) {
            document.removeEventListener(documentClickEvent, this.handler);
        }
        this.isOpen = false;
    };
    StickyTooltipComponent.prototype.onDocumentClick = function (event) {
        var _this = this;
        var targets = event.composedPath
            ? event.composedPath()
            : [event.target];
        var isTooltip = targets.some(function (target) { return target === _this.$el; });
        if (!isTooltip) {
            this.closeTooltip();
        }
    };
    StickyTooltipComponent = __decorate([
        Component({
            name: 'ui-sticky-tooltip',
        })
    ], StickyTooltipComponent);
    return StickyTooltipComponent;
}(Mixins(MagicConfigMixin)));

export default StickyTooltipComponent;
